/* eslint-disable sort-keys */

import whiteQkLogo from "../../media/ard-quizkit-logo-white.png"

export const skin = {
  bannerImage: whiteQkLogo,
  timerImage: whiteQkLogo,
  // primaryFont: "Arial Rounded",
  // secondaryFont: "Arial Rounded",
  // primaryColor: "#0F1635",
  // secondaryColor: "#FFFFFF",
  // primaryFontColor: "#FFFFFF",
  // secondaryFontColor: "#0F1635",
  // variables: "#1FA7DF",
  // timerBackgroundColor: "#4F4F4F",
  // highlightColor: "#EC8B1C",
  // correctBackgroundColor: "#6CD379",
  // correctForegroundColor: "#2DB5AB",
  // wrongBackgroundColor: "#EA116F",
  // wrongForegroundColor: "#BC0F62",
  // incorrectColor: "#CECECE",
  // roundLeaderboardColor: "#cb357e",
  // totalLeaderboardColor: "#1fa2d8",
  // finalLeaderboardColor: "#583ca2"
}

export const updateSkinValue = (key, value) => {
  skin[key] = value
}
